<p>offer-edit-position works!</p>
<form clrForm
      [formGroup]="editOffersForm">
  <table class="table" id="positionsTable">
    <thead>
    <tr>
      <th class="left">Position</th>
      <th class="left">Bezeichnung</th>
      <th class="left">Zeichnungsnummer</th>
      <th class="left">Material</th>
      <th class="left">Gewicht (in kg)</th>
      <th>Anzahl</th>
      <th>Angebot in EUR</th>
      <th class="left">PDF</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>{{ editPosition }}<span *ngIf="editPart !== 0">.{{ editPart }}</span></td>
      <td class="left">
        {{ positions[0].name }}
        <span *ngIf="((!positions[0].description) || (positions[0].description.length > 0))"><br />{{ positions[0].description }}</span>
      </td>
      <td class="left">{{ positions[0].technical_drawing }}</td>
      <td class="left">{{ positions[0].material }}</td>
      <td class="left"><input type="text" formControlName="weight" placeholder="{{ positions[0].weight }} " class="clr-input" value="{{ positions[0].weight }} "></td>
      <td><input type="text" formControlName="number_of_pieces" placeholder="{{ positions[0].number_of_pieces }}" class="clr-input" value="{{ positions[0].number_of_pieces }}"></td>
      <td><input type="text" formControlName="selling_price" placeholder="{{ positions[0].selling_price }}" class="clr-input" value="{{ positions[0].selling_price }}"></td>
      <td class="left"><input  type="checkbox" clrCheckbox formControlName="for_pdf" value="{{ positions[0].for_pdf }}" /></td>
      <td rowspan="3" class="btn-group btn-primary btn-icon">
        <button class="btn btn-sm" (click)="updateOffersPosition()" [disabled]="editOffersForm.invalid">
          <cds-icon shape="floppy"></cds-icon>
          <span class="clr-icon-title">Speichern</span>
        </button>
      </td>
    </tr>
    <tr *ngIf="positions[0].specification">
      <td colspan="4"></td>
      <td colspan="3" class="left"><b>Spezifikation:</b> {{ positions[0].specification }}</td>
    </tr>
    <tr *ngIf="positions[0].comment_phm">
      <td colspan="4"></td>
      <td colspan="3" class="left"><b>Kommentar:</b> {{ positions[0].comment_phm }}</td>
    </tr>
    <tr>
      <td colspan="3"></td>
      <td colspan="4" class="left">
        <div class="clr-form-control">
          <label for="remarks" class="clr-control-label">Leistungsumfang</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              <textarea formControlName="remarks" id="remarks" placeholder="{{ positions[0].remarks }}" cols="100" rows="10" class="clr-textarea" value="{{ positions[0].remarks }}"></textarea>
              <cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
            </div>
            <span class="clr-subtext">Dieses Feld erscheint im Dokument unter der Position.</span>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="3"></td>
      <td colspan="4" class="left">
        <div class="clr-form-control">
          <label for="remarks" class="clr-control-label">Nebenabreden mit dem Kunden</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              <textarea formControlName="side_agreements" id="side_agreements" placeholder="{{ positions[0].side_agreements }}" cols="100" rows="10" class="clr-textarea" value="{{ positions[0].side_agreements }}"></textarea>
              <cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
            </div>
            <span class="clr-subtext">Die Nebenabreden werden später bei einem eventuellen Job berücksichtigt.</span>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</form>

<pre *ngIf="devMode" class="datepicker-output">
    {{ editOffersForm.value | json }}
</pre>


